import { useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import useApi, { UPDATE_CANNED_DASHBOARD_SET, RESET_CANNED_DASHBOARD_SET } from 'hooks/useApi';
import UserContext from 'context/UserSessionContext';

import * as DASHBOARD_ACTIONS from 'hooks/useFetchCannedDashboardList/actions';

import { updateNavigationDashboards } from 'utils/widget-helpers';

const useCannedDashboardsManipulation = (masterObjectId, dispatchCannedDashboardList) => {
  const { id } = useParams();
  const history = useHistory();

  const { session } = useContext(UserContext);
  const { portfolios, holdings } = session;

  const [state, makeRequest] = useApi();
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    function findDefaultDashboardId(dashboards) {
      const defaultDashboard = dashboards.find(dashboard => dashboard.isDefaultScreen === true);

      if (defaultDashboard) {
        const { id: dashId } = defaultDashboard;
        return dashId;
      }

      const firstDashboard = dashboards.find(dashboard => dashboard.ordinal === 1);
      const { id: dashId } = firstDashboard;
      return dashId;
    }

    if (isLoading) {
      return;
    }

    if (isError) {
      return;
    }

    if (data) {
      const { dashboards } = data;

      const isOnValidRoute = dashboards.find(dashboard => dashboard.id === id);
      const defaultDashboardId = findDefaultDashboardId(dashboards);

      dispatchCannedDashboardList({ type: DASHBOARD_ACTIONS.DASHBOARD_LIST_READY, payload: data });

      // This function changes the value of user context property directly without dispatching an action! KEEP IN MIND!
      // This is far from best practice but dispatching a context action will cause the entire app to re-render this way the navigation values are changed
      // and the Page component re-render due to the redirect and the changes are in effect on the Navigation
      updateNavigationDashboards({
        portfolios,
        holdings,
        masterObjectId,
        dashboards
      });

      if (!isOnValidRoute) {
        history.replace(`/canned/${masterObjectId}/${defaultDashboardId}`);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isError, error, data, dispatchCannedDashboardList]);

  const updateDashboardSet = ({
    newDashboardId,
    firstOrdinal,
    secondOrdinal,
    objectTypeDetailId,
    objectType,
    name
  }) => {
    const dashboardSetParams = UPDATE_CANNED_DASHBOARD_SET({
      newDashboardId,
      firstOrdinal,
      secondOrdinal,
      masterObjectId,
      objectTypeDetailId,
      objectType,
      name
    });
    makeRequest(dashboardSetParams);
  };
  const resetDashboardSet = () => {
    const dashboardSetParams = RESET_CANNED_DASHBOARD_SET({
      masterObjectId
    });
    makeRequest(dashboardSetParams);
  };

  return [state, updateDashboardSet, resetDashboardSet];
};

export default useCannedDashboardsManipulation;
